import classNames from "classnames";
import React from "react";
import "./Radio.scss";

const Radio = ({ name, label, checked, onChange, id, disabled }) => {
  return (
    <label
      className={classNames("lp_radio", {
        "lp_radio--disabled": disabled
      })}
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={"outer"} />
      <span
        className={"font-medium text-sm py-1 flex gap-2 px-0 text-black mb-0"}
      >
        {label}
      </span>
    </label>
  );
};

export default Radio;
